import { render } from "./management.cattle.io.roletemplate.vue?vue&type=template&id=11b6b638&scoped=true"
import script from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.roletemplate.vue?vue&type=script&lang=js"

import "./management.cattle.io.roletemplate.vue?vue&type=style&index=0&id=11b6b638&lang=scss&scoped=true"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b6b638"]])

export default __exports__